import React, { useState, useCallback } from 'react';
import { NavLink } from 'react-router-dom';

//Bootstrap
import { Container, Row, Col } from 'react-bootstrap';

// import './Products.css';
import Title from '../Title/Title';
import TypeButton from './TypeButton/TypeButton';
import ProductItem from './ProductItem/ProductItem';

const Products = (props) => {
    const [typeSelected, setTypeSelected] = useState(0);

    const handlerSelectedType = useCallback((type) => {
        setTypeSelected(type);
        props.fetchPostsByType(type);
    }, [props]);

    const products = props.posts.map(p => {
        return {
            id: p.ID,
            type: decodeURIComponent(p.TIPO),
            pathname: `/trabajos/${p.URL_POST}`,
            title: decodeURIComponent(p.TITULO),
            date: `${p.FECHA.substring(8, 10)}/${p.FECHA.substring(5, 7)}/${p.FECHA.substring(0, 4)}`,
            img: `./assets/images/${p.IMAGEN_PRINCIPAL}`,
            alt: decodeURIComponent(p.TITULO),
            description: `${decodeURIComponent(p.DESCRIPCION.slice(0, 350))}${p.DESCRIPCION.length > 350 ? "..." : ""}`,
            spotify: p.LINK_SPOTIFY ? true : false,
            linkSpotify: p.LINK_SPOTIFY ? decodeURIComponent(p.LINK_SPOTIFY) : null,
            youtube: p.LINK_YOUTUBE ? true : false,
            linkYoutube: p.LINK_YOUTUBE ? decodeURIComponent(p.LINK_YOUTUBE) : null,
            instagram: p.LINK_INSTAGRAM ? true : false,
            linkInstagram: p.LINK_INSTAGRAM ? decodeURIComponent(p.LINK_INSTAGRAM) : null,
            video: parseInt(p.TIENE_VIDEO) === 1 ? true : false,
            audio: parseInt(p.TIENE_AUDIO) === 1 ? true : false,
            article: parseInt(p.TIENE_ARTICULO) === 1 ? true : false
        }
    })

    return (
        <Container fluid className="p-5 text-left">
            <Row className="mx-md-5">
                <Col>
                    <Title textLight="Mis " textBold="Trabajos" titleType="h1" />
                </Col>
            </Row>
            <Row className="py-3">
                <Col>
                    <div className="text-center">
                        {props.productTypes.map(p =>
                            <TypeButton key={p.ID} text={decodeURIComponent(p.NOMBRE)} selected={typeSelected === p.ID ? true : false} click={() => handlerSelectedType(p.ID)} />)}
                    </div>
                </Col>
            </Row>
            {products.length > 0 ?
                <React.Fragment>
                    <div className="pt-5">
                        <Title textLight="Últimos Posts" textBold="" titleType="h4" />
                    </div>
                    {products.map(p => <ProductItem key={p.id} {...p} typeSelected={typeSelected} />)}
                </React.Fragment>
                :
                <div className="pt-5">
                    <Title textLight="No se han encontrado posts para el filtro seleccionado" textBold="" titleType="h4" />
                </div>
            }

            {props.fromHome ?
                <Row className="py-4 text-center">
                    <Col>
                        <NavLink to={{ pathname: "/trabajos" }} className="btn custom-btn py-2 px-3">Ver Más</NavLink>
                    </Col>
                </Row>
                : null}
        </Container>
    );
};

export default Products;